import React, { useState } from 'react';
import '../App.css';

const videos = [
  {
    title: '概要方案（2分钟）',
    desc: '快速了解千流智能随访系统的随访功能与核心亮点',
    src: '//player.bilibili.com/player.html?bvid=BV1Wh3azrERD&page=1',
    poster: '/eprocover.png',
  },
  {
    title: '方案概要（21分钟）',
    desc: '在线培训1-健康系统方案概要',
    src: '//player.bilibili.com/player.html?bvid=BV1gf3azpEC6&page=1',
    poster: '/summarycover.png',
  },
  {
    title: '功能展示（7分钟）',
    desc: '在线培训2-方案展示',
    src: '//player.bilibili.com/player.html?bvid=BV1MA3YzSEqJ&page=1',
    poster: '/detailcover.png',
  },
];

function DemoVideo() {
  const [active, setActive] = useState(0);
  const [loading, setLoading] = useState(true);
  const current = videos[active];
  const isBilibili = current.src.includes('bilibili.com/player.html');

  // 监听tab切换时重置loading
  React.useEffect(() => { setLoading(true); }, [active]);

  return (
    <section id="video">
      <h2>产品与培训视频</h2>
      <div className="section-subtitle">了解千流智能随访系统的核心功能与操作体验</div>
      <div className="video-tabs">
        {videos.map((v, i) => (
          <button
            key={i}
            className={active === i ? 'video-tab active' : 'video-tab'}
            onClick={() => setActive(i)}
          >
            {v.title}
          </button>
        ))}
      </div>
      <div style={{marginTop: 8}}>
        <div className="video-desc">{current.desc}</div>
        <div className="video-container">
          {loading && (
            <div className="video-loading">
              <span style={{color: '#009900', fontWeight: 700, fontSize: 18}}>视频加载中…</span>
            </div>
          )}
          {isBilibili ? (
            <iframe
              src={current.src}
              title={current.title}
              frameBorder="0"
              allowFullScreen
              loading="lazy"
              className="video-player"
              onLoad={() => setLoading(false)}
            ></iframe>
          ) : (
            <video
              key={active}
              controls
              poster={current.poster}
              className="video-player"
              onLoadedData={() => setLoading(false)}
            >
              <source src={current.src} type="video/mp4" />
              您的浏览器不支持视频播放。
            </video>
          )}
        </div>
      </div>
    </section>
  );
}
export default DemoVideo; 